// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"RemoveSale_text-gradient__3MhWv","text":"RemoveSale_text__ziFsi","btns":"RemoveSale_btns__lNcwN","button":"RemoveSale_button__2SiMY"};